const SAMPLE_FEEDBACK_URL = 'https://feedback.up2promo.com/invite/••••';
const SAMPLE_UNSUBSCRIBE_URL = 'https://feedback.up2promo.com/unsubscribed';

export type FeedbackMailSampleVars = {
  contactName: string;
  locationName: string;
  workspaceName: string;
  feedbackUrl?: string;
  unsubscribeUrl?: string;
};

/** Fill Handlebars-style invite variables for in-app email preview. */
export function interpolateFeedbackMailPreview(
  template: string,
  sample: FeedbackMailSampleVars,
): string {
  const vars: Record<string, string> = {
    contactName: sample.contactName,
    locationName: sample.locationName,
    workspaceName: sample.workspaceName,
    feedbackUrl: sample.feedbackUrl ?? SAMPLE_FEEDBACK_URL,
    unsubscribeUrl: sample.unsubscribeUrl ?? SAMPLE_UNSUBSCRIBE_URL,
  };
  return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, key: string) => {
    return vars[key] ?? `{{${key}}}`;
  });
}

/**
 * Name for the compose mail preview: the first recipient with a name, so the
 * user sees the mail as that guest gets it; else the sample guest.
 */
export function feedbackPreviewContactName(
  recipients: ReadonlyArray<{ name?: string | null }>,
  fallback: string,
): string {
  for (const recipient of recipients) {
    const name = recipient.name?.trim();
    if (name) return name;
  }
  return fallback;
}

export const FEEDBACK_MAIL_VARIABLES = [
  { key: 'contactName', insert: '{{contactName}}' },
  { key: 'locationName', insert: '{{locationName}}' },
  { key: 'workspaceName', insert: '{{workspaceName}}' },
  { key: 'feedbackUrl', insert: '{{feedbackUrl}}' },
  { key: 'unsubscribeUrl', insert: '{{unsubscribeUrl}}' },
] as const;
